import { useState, useEffect, useRef } from "react";
import { Divider, Box, Button, CardMedia, IconButton } from "@mui/material";
import Detail from "../main/detail/Detail";
import MagPageContents from "./MagPageContents";
import MagPageContentRows from "./MagPageContentRows";
import { rsActiveMenu, rsParentCom, rsProgress } from "../RecoilStates";
import { useRecoilState } from "recoil";
import { UseMagManagment } from "./UseMagManagment";
import Header from "../images/Content/Header1.png";
import Footer from "../images/Content/Footer.png";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMagLandings } from "./mag-Landing/UseMagLandings";
import useBreakpoints from "../hooks/useBreakpoints";
// import { UseOffer } from "./HomeOffer/UseOffer";

export default function MagManagment() {
  const navigate = useNavigate();
  // const { UpdateOffersDataAll, UpdateOffersAll } = UseOffer();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const {
    GetComponents,
    SetComponents,
    removeComponent,
    ResetHeaderFooterCache,
  } = UseMagManagment();
  const { UpdateHomePageMags } = UseMagLandings();
  const [openDialog, setOpenDialog] = useState(false);
  const [components, setComponents] = useState();
  const [msParentCom, setMsParentCom] = useRecoilState(rsParentCom);
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    setProgress(true);
    GetComponents((components) => {
      setComponents(components);
    }, true);
  }, []);

  return (
    <Detail
      breadChilds={{
        normargin: true,
        title: "مدیریت محتوا",
        childs: [{ name: msActiveMenu.pageTitle, url: "/magmanagment" }],
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            backgroundColor: "#F5F5F5",
            height: "100%",
          }}
        >
          <Box sx={{ position: "relative" }}>
            <Box
              sx={{
                mb: 2,
                display: "flex",
                alignItems: "flex-end",
                position: "relative",
                width: isSmall ? "100%" : "60%",
                mx: "auto",
              }}
            >
              <CardMedia component="img" image={Header} />
              <Box
                sx={{
                  py: 1,
                  position: "absolute",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                  zIndex: 1000,
                  right: 5,
                }}
              >
                <IconButton
                  onClick={(evt) => {
                    setMsParentCom({
                      backUrl: "/magmanagment",
                      parentComs: "/magHeaderManage",
                    });
                    navigate("/magHeaderManage");
                  }}
                  sx={{
                    p: 0.7,
                    mr: 1,
                    bgcolor: "secondary.main",
                    "&:hover": {
                      boxShadow: 3,
                      bgcolor: "secondary.main",
                    },
                  }}
                >
                  <EditIcon fontSize="small" sx={{ fill: "#fff" }} />
                </IconButton>
                {/* <IconButton
                  onClick={(evt) => {
                    setProgress(true);
                    ResetHeaderFooterCache((csssc) => {
                      setProgress(false);
                    });
                  }}
                  sx={{
                    p: 0.7,
                    mr: 1,
                    bgcolor: "secondary.main",
                    "&:hover": {
  boxShadow: 3,
                      bgcolor: "secondary.main",                    },
                  }}
                >
                  <RefreshIcon fontSize="small" sx={{ fill: "#fff" }} />
                </IconButton> */}
              </Box>
            </Box>
          </Box>
          <MagPageContentRows
            callback={(tempRow) => {
              SetComponents(tempRow, () => {
                GetComponents((components) => {
                  setComponents(components);
                }, true);
              });
            }}
            callbackRemove={(AID) => {
              removeComponent(AID, () => {
                GetComponents((components) => {
                  setComponents(components);
                }, true);
              });
            }}
            row={components}
            setRow={setComponents}
          />
          <Box sx={{ position: "relative" }}>
            <Box
              sx={{
                mb: 2,
                display: "flex",
                alignItems: "flex-end",
                position: "relative",
                width: isSmall ? "100%" : "60%",
                mx: "auto",
              }}
            >
              <CardMedia component="img" image={Footer} />
              <Box
                sx={{
                  py: 1,
                  position: "absolute",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                  zIndex: 1000,
                  right: 5,
                }}
              >
                <IconButton
                  onClick={(evt) => {
                    setMsParentCom({
                      backUrl: "/magmanagment",
                      parentComs: "/magFooterManage",
                    });
                    navigate("/magFooterManage");
                  }}
                  sx={{
                    p: 0.7,
                    mr: 1,
                    bgcolor: "secondary.main",
                    "&:hover": {
                      boxShadow: 3,
                      bgcolor: "secondary.main",
                    },
                  }}
                >
                  <EditIcon fontSize="small" sx={{ fill: "#fff" }} />
                </IconButton>
                {/* <IconButton
                  onClick={(evt) => {
                    setProgress(true);
                    ResetHeaderFooterCache((csssc) => {
                      setProgress(false);
                    });
                  }}
                  sx={{
                    p: 0.7,
                    mr: 1,
                    bgcolor: "secondary.main",
                    "&:hover": {
  boxShadow: 3,
                      bgcolor: "secondary.main",                    },
                  }}
                >
                  <RefreshIcon fontSize="small" sx={{ fill: "#fff" }} />
                </IconButton> */}
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
          }}
        >
          <Divider />
          <Box
            sx={{
              display: "flex",
              p: 2,
              justifyContent: "space-between",
            }}
          >
            <Button
              sx={{ width: "100px" }}
              variant="contained"
              onClick={() => {
                setOpenDialog(true);
              }}
            >
              آیتم جدید
            </Button>
            <Box>
              <Button
                sx={{ width: "140px", mr: 2 }}
                variant="contained"
                onClick={() => {
                  setProgress(true);
                  setProgress(true);
                  UpdateHomePageMags(0, (callback) => {
                    setProgress(false);
                  });
                }}
              >
                به‌روزرسانی مقالات
              </Button>
              <Button
                color="secondary"
                sx={{ width: "100px" }}
                variant="contained"
                onClick={() => {
                  SetComponents(components, () => {
                    GetComponents((components) => {
                      setComponents(components);
                    }, true);
                  });
                }}
              >
                ثبت
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
      {openDialog && (
        <MagPageContents
          row={components}
          setRow={setComponents}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          components={components}
          callback={(tempRow) => {
            SetComponents(tempRow, () => {
              GetComponents((components) => {
                setComponents(components);
              }, true);
            });
          }}
        />
      )}
    </Detail>
  );
}
